import { toCodePointChar } from "#to-code-point-char";

/** Matches a leading UTF-16 surrogate code point (general category Cs). */
export const SURROGATE_REGEX = /^\p{Surrogate}/u;

/** True if the first code point is a UTF-16 surrogate (general category Cs): U+D800–U+DFFF. */
export function isSurrogate(value: string | number): boolean {
  return SURROGATE_REGEX.test(toCodePointChar(value));
}
